@if(type=== 'hotel'){
<app-hotel-description [data]="routeData"></app-hotel-description>
}@else if(type === 'destination'){
<app-hotel-search [data]="routeData"></app-hotel-search>
}
